var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{attrs:{"as":"span","data-drag-handle":""}},[_c('span',{staticClass:"smart-object",class:{ selected: _vm.selected },attrs:{"data-smart-object":"simplePlaceholder","data-id":_vm.node.attrs.id}},[_vm._v(_vm._s(_vm.$tc('common.correspondence.smart-object.' + _vm.normalizeTranslationId(_vm.node.attrs.id), 1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }